"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "displayErrors", "hasError", "hasValidation", "inputClassName", "setDisplayErrorsState", "setLoadingState", "theme"];
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      backgroundColor: theme.colors.blueGrey,
      borderRadius: theme.variables.borderRadius
    }
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLElement & {
    displayErrors?: boolean,
    hasError?: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed
  };*/
var BuilderListView = function BuilderListView(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    displayErrors = _ref /*:: */.displayErrors,
    hasError = _ref /*:: */.hasError,
    hasValidation = _ref /*:: */.hasValidation,
    inputClassName = _ref /*:: */.inputClassName,
    setDisplayErrorsState = _ref /*:: */.setDisplayErrorsState,
    setLoadingState = _ref /*:: */.setLoadingState,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
BuilderListView.displayName = 'BuilderListView';
var _default = exports.default = (0, _injectSheet.default)(Style)(BuilderListView);
//# sourceMappingURL=BuilderListView.js.map